import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { deleteCookie } from "../../utils/getCookie";
import { appText } from "./../../texts";
import { FiLogOut, FiDownload, FiSettings } from "react-icons/fi";
import { motion } from "framer-motion";
import DropDown from "./components/DropDown";
const { headerText } = appText;

export default function Header({ isSuperAdmin }) {
  const { pathname } = useLocation();

  const handleLogout = () => {
    deleteCookie("access_token");
    deleteCookie("refresh_token");
    window.location.href = "/login";
  };

  return (
    <div>
      <motion.header
        className='w-full px-4 md:px-10 py-4 bg-white shadow-md flex flex-col md:flex-row items-center justify-between gap-4 z-10'
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* لوگوها */}
        <div className='flex items-center gap-4 w-full md:w-auto justify-between md:justify-start'>
          <img
            src='images/logo.svg'
            alt='لوگو اصلی'
            className='h-10 object-contain w-48'
          />
        </div>
        <img
          src='images/logo-bime.svg'
          alt='لوگو بیمه'
          className='hidden md:block h-10  w-48 object-contain'
        />
        {/* دکمه‌ها */}
        <div className='flex items-center gap-3'>
          <DropDown />
          {/* روی خود /admin دکمه چیزی به کاربر اضافه نمی‌کند، پس پنهان می‌شود. */}
          {isSuperAdmin && pathname !== "/admin" && (
            <Link
              to='/admin'
              className='flex items-center gap-2 bg-[#0B7285] hover:bg-[#095c6b] text-white font-semibold py-2 px-4 rounded-xl transition duration-300'
            >
              <FiSettings className='text-white text-lg' />
              <span className='text-sm'>{headerText.adminText}</span>
            </Link>
          )}
          <button
            onClick={handleLogout}
            className='flex items-center gap-2 bg-[#02BFE7] hover:bg-[#087c93] text-white font-semibold py-2 px-4 rounded-xl transition duration-300'
          >
            <FiLogOut className='text-white text-lg' />
            <span className='text-sm'>{headerText.logoutText}</span>
          </button>
        </div>
      </motion.header>
    </div>
  );
}
